import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { UnsavedModalComponent } from '../../unsaved-modal/unsaved-modal.component';
import { FormGroup } from '@angular/forms';
export interface CanComponentDeactivate {
  getForm: () => FormGroup;
  saveChanges: () => Observable<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component,
) => {
  const modalService = inject(NgbModal);
  const form = component.getForm();

  if (form.dirty) {
    const modalRef = modalService.open(UnsavedModalComponent, {
      centered: true,
      backdrop: 'static',
    });

    modalRef.componentInstance.isValidForm = form.valid;

    return new Observable<boolean>((observer) => {
      modalRef.result.then(
        (result) => {
          if (result === 'yes') {
            component.saveChanges().subscribe({
              next: (saveSuccessful) => {
                observer.next(saveSuccessful);
                observer.complete();
              },
              error: (error) => {
                observer.next(false);
                observer.complete();
              },
            });
          } else if (result === 'no') {
            observer.next(true); // Discard changes
            observer.complete();
          } else if (result == 'dismissed') {
            observer.next(false);
          }
        },
        () => {
          observer.next(false); // Modal dismissed
          observer.complete();
        },
      );
    });
  }

  return true; // Not dirty
};
